export default "__VITE_ASSET__Cgvq6ysW__"